import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '../../UserProvider';
import { clearAuth } from '../../utils/api';

export default function LogoutPage() {
  const navigate = useNavigate();
  const { setCurrentUser } = useCurrentUser();

  useEffect(() => {
    clearAuth();
    setCurrentUser(null);
    navigate('/login', { replace: true });
  }, [navigate, setCurrentUser]);

  return null; // or a spinner if you want
}